// extracted by mini-css-extract-plugin
export default {"header_container":"Logo_header_container__+w1ZP"};